import api from '@/services/api'

/**
 * 获取营业报表
 */
export function getBusinessReport(params = {}) {
  return api.get('/report/business', { params })
}

/**
 * 应收报表-客户应收总表
 */
export function getReceivableSummary(params = {}) {
  return api.get('/report/receivable/summary', { params })
}

/**
 * 应收报表-搜索客户
 */
export function searchCustomers(keyword) {
  return api.get('/report/receivable/customers/search', { params: { keyword } })
}

/**
 * 应收报表-客户订单列表
 */
export function getCustomerReceivableDetail(customerId) {
  return api.get(`/report/receivable/customer/${customerId}`)
}

/**
 * 应收报表-打印数据
 */
export function getReceivablePrintData(customerId) {
  return api.get(`/report/receivable/print/${customerId}`)
}

/**
 * 获取客户未收款汇总（用于小票打印）
 * @param {number} customerId 客户ID
 * @param {number} wholesalerId 批发商ID（可选，用于按批发商过滤）
 */
export function getReceivableForPrint(customerId, wholesalerId) {
  const params = wholesalerId ? { wholesalerId } : {}
  return api.get(`/report/receivable/for-print/${customerId}`, { params })
}
